import React, { useState } from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

// import ZoneAssignmentSearchInput from "../ZoneAssignmentSearchInput";
import ZoneAssignmentSearchInput from "./ZoneAssignmentSearchInput";
import ZonesAssignmentTable from "./ZonesAssignmentTable";

function ZoneAssignmentsTab() {
  const [searchValue, setSearchValue] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const updateSearchValue = (value) => {
    setSearchValue(value);
  };

  return (
    <div>
      <Container maxWidth={false} sx={{ my: 3}}>
        <ZonesAssignmentTable
          searchInput={searchValue}
          updateSearchValue={updateSearchValue}
          updateRefreshKey={setRefreshKey}
        />
      </Container>
    </div>
  );
}

export default ZoneAssignmentsTab;
